module.exports = __webpack_public_path__ + "img/m70-banner.9124c26f.png";